import { useQuery } from "react-query";
import { GetTimeAltResponse } from "../../constants/types";
import axios from "../axios";

const queryString = require("query-string");

const handleRequest = async () => {
    const apiGetTime = queryString.stringifyUrl({
        url: "api/timezone",
    });
    const { data } = await axios.get<GetTimeAltResponse>(apiGetTime);
    return data;
};

export default function useTimeAlt() {
    return useQuery<GetTimeAltResponse>(["time-alt"], () => handleRequest());
}
